import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/auth/keycloak/services/auth.service';

@Component({
  selector: 'app-error-auth',
  standalone: false,
  templateUrl: './error-auth.component.html',
  styleUrl: './error-auth.component.scss',
})
export class ErrorAuthComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  goBack() {
    window.location.href = environment.auth_environment.REDIRECT_GUARD_RUTE;
  }

  async signOut() {
    await this.authService.logout();
  }
}
